import classNames from 'classnames/bind';
import History from 'main/common/history';
import Everywhere from './Everywhere';
import Theme from './Theme';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const SEARCH_HISTORY_COUNT = 5;

export default function Normal() {
  return (
    <>
      <History count={SEARCH_HISTORY_COUNT} />
      <section className={cx('Normal_section')}>
        <div className={cx('inner')}>
          <Everywhere />
        </div>
      </section>
      <Theme />
    </>
  );
}
